export const HIDE_COLUMN_CLASS_NAME = 'HideColumn';
